import { type FunctionComponent, useContext } from 'react';
import { type ProductVariantFieldsFragment } from '../../../__generated__/graphql-client-types';
import { VariantContext } from '../../../contexts/variant/variant.context';
import { hasRestrictions } from '../../../helpers/product-helper/product.helper';
import { Variant } from '../variant/variant.component';

export type VariantSelectorProps = {
	familyId: number;
	variants?: ProductVariantFieldsFragment[];
};

export const VariantSelector: FunctionComponent<VariantSelectorProps> = ({ familyId, variants = [] }) => {
	const { setHoveredVariant, setSelectedVariant, currentVariant } = useContext(VariantContext);
	// exit early and render nothing if there are no variants
	if (variants.length === 0) {
		return null;
	}
	return (
		<div className={`list flex flex-row flex-wrap justify-start mt1 lh-solid`} data-testid="variants">
			{variants.map((variant) => (
				<Variant
					key={variant.id.toString()}
					onSelectVariant={setSelectedVariant}
					onHover={setHoveredVariant}
					variant={variant}
					currentVariant={currentVariant}
					showRestrictionWarning={hasRestrictions(variant, familyId)}
					className={`ma0 pr2 pt2`}
				/>
			))}
		</div>
	);
};
